import { config } from "../config";

const SUBSCRIPTION_PLANS_PRODUCTION = {
  10: { paypalPlanId: "P-92D36671GN7871549L3VDKTA", planId: "GWMB1" },
  20: { paypalPlanId: "P-8A0497736X240415VL3VDMBI", planId: "GWMA1" },
  100: { paypalPlanId: "P-3AW38896WA450370WL3VDM5Q", planId: "GWAB1" },
  200: { paypalPlanId: "P-5XD034121H339400HL3VDNMA", planId: "GWAA1" },
};

const SUBSCRIPTION_PLANS_SANDBOX = {
  10: { paypalPlanId: "P-8G874870RB654210JL3MZEKA", planId: "GWMB1" },
  20: { paypalPlanId: "P-8G874870RB654210JL3MZEKA", planId: "GWMA1" },
  100: { paypalPlanId: "P-9A297909YS720713AL3MZDYI", planId: "GWAB1" },
  200: { paypalPlanId: "P-9A297909YS720713AL3MZDYI", planId: "GWAA1" },
};

export function getPaypalClientId() {
  return config.paypal.clientId || "";
}

export function isPaypalConfigured() {
  return Boolean(getPaypalClientId());
}

export function getPaypalSubscriptionOptions() {
  return {
    clientId: getPaypalClientId(),
    vault: true,
    intent: "subscription",
    currency: "USD",
  };
}

export function getPaypalOnePayOptions() {
  return {
    clientId: getPaypalClientId(),
    vault: true,
    currency: "USD",
  };
}

export function getSubscriptionPlan(planValue) {
  const plans = config.paypal.sandbox
    ? SUBSCRIPTION_PLANS_SANDBOX
    : SUBSCRIPTION_PLANS_PRODUCTION;
  return plans[planValue] || null;
}

export function getPaypalApiUrl(endpoint) {
  const base = config.api.godiway.replace(/\/+$/, "");
  const path = endpoint.replace(/^\//, "");
  return `${base}/paypal/${path}`;
}

export function postSubscriptionToBackend({
  data,
  details,
  userId,
  token,
  planGwId,
}) {
  return fetch(getPaypalApiUrl("subscription-godiway"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      order_id: data.orderID,
      subscription_id: data.subscriptionID,
      id: userId,
      details,
      plan_id: planGwId,
    }),
  });
}
